import React from "react";
import * as Mui from "@mui/material";
import { Task } from "model/task";
import { Lead } from "model/lead";
import { Agent } from "model/agent";
import { User } from "model/user";
import { agentTasksDev } from "shared/env";
import { TaskCardLeft } from "./task-card-left";
import { TaskCardRight } from "./task-card-right";

interface Props {
	task: Task;
	lead?: Lead;
	agent?: Agent;
	user: User;
	assigner?: Agent;
	ownsTask: boolean;
	checked: boolean;
	disabled: boolean;
	theme: Mui.Theme;
	classes: Record<string, string>;
	onToggleCheckbox: () => void;
	onTogglePriority: () => void;
	onDelete: () => void;
	onEdit: () => void;
}

export const TaskCardContent: React.FC<Props> = ({
	task,
	lead,
	agent,
	user,
	assigner,
	ownsTask,
	checked,
	disabled,
	theme,
	classes,
	onToggleCheckbox,
	onTogglePriority,
	onDelete,
	onEdit,
}) => {
	return (
		<>
			<TaskCardLeft
				task={task}
				lead={lead}
				agent={agent}
				user={user}
				assigner={assigner}
				ownsTask={ownsTask}
				checked={checked}
				classes={classes}
				onToggleCheckbox={onToggleCheckbox}
			/>
			<TaskCardRight
				task={task}
				disabled={disabled}
				theme={theme}
				classes={classes}
				onTogglePriority={onTogglePriority}
				onDelete={onDelete}
				onEdit={onEdit}
			/>
		</>
	);
};
